(ns minorodata.sql-console-modal.subs
  (:require [clojure.string]
            [re-frame.core :as re-frame]))


(re-frame/reg-sub
 :sql-console-modal.subs/modal-open?
 (fn [db _]
   (get-in db [:sql-console-modal/state :open?])))

(re-frame/reg-sub
 :sql-console-modal.subs/unit-tests-modal-open?
 (fn [db _]
   (get-in db [:app/modals :transform-unit-tests :open?])))

(re-frame/reg-sub
 :sql-console-modal.subs/unit-tests-modal-transform
 (fn [db _]
   (get-in db [:app/modals :transform-unit-tests :transform])))

(re-frame/reg-sub
 :sql-console-modal.subs/unit-tests-modal-output-tables
 (fn [db _]
   (get-in db [:app/modals :transform-unit-tests :output-tables])))

(re-frame/reg-sub
 :sql-console-modal.subs/db-copy-modal-open?
 (fn [db _]
   (get-in db [:app/modals :db-copy :open?])))


(re-frame/reg-sub
 :sql-console-modal.subs/current-environment-id
 (fn [db _]
   (get-in db [:db-copy-modal/selected-environment-id])))
